import { ColorTokenKey } from '../../indigofair/data/ColorTokenKey';
import { IAction } from '../../indigofair/data/IAction';
import { IElementLoggingData } from '../../indigofair/data/IElementLoggingData';
import { IFaireIcon } from '../../indigofair/data/IFaireIcon';

export namespace IButtonElement {
  /**
   * The tags are out of order. All tag numbers must be unique. When adding fields, also update the field below and the tag number.
   * See https:www.notion.so/faire/Protocol-Buffers-Protos-ba527d2f70c34ab983b8d0417c6a56ac#6a792ceb9d37498795a117e712b9e7e7 for details.
   * The last tag added was `iconAndText`. The next tag number is 9.
   */
  export enum ButtonVariant {
    BUTTON_VARIANT_UNKNOWN = 'BUTTON_VARIANT_UNKNOWN',
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    TERTIARY = 'TERTIARY',
  }

  export namespace IButtonStyle {
    /**
     * Return an instance of IButtonStyle with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (partial?: Partial<IButtonStyle>): IButtonStyle =>
      ({
        ...(partial ?? {}),
      }) as IButtonStyle;
  }

  export interface IButtonStyle {
    background_color: keyof typeof ColorTokenKey | undefined;
    color: keyof typeof ColorTokenKey | undefined;
  }

  export namespace IFaireIconText {
    export enum FaireIconPosition {
      FAIRE_ICON_POSITION_UNKNOWN = 'FAIRE_ICON_POSITION_UNKNOWN',
      START = 'START',
      END = 'END',
    }

    /**
     * Return an instance of IFaireIconText with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (partial?: Partial<IFaireIconText>): IFaireIconText =>
      ({
        ...(partial ?? {}),
      }) as IFaireIconText;
  }

  export interface IFaireIconText {
    text: string | undefined;
    icon: IFaireIcon | undefined;
    icon_position:
      | keyof typeof IButtonElement.IFaireIconText.FaireIconPosition
      | undefined;
  }

  /**
   * Return an instance of IButtonElement with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IButtonElement>): IButtonElement =>
    ({
      on_click: [],
      ...(partial ?? {}),
    }) as IButtonElement;
}

/**
 * Sub-Elements
 */
export interface IButtonElement {
  variant: keyof typeof IButtonElement.ButtonVariant | undefined;
  style_override: IButtonElement.IButtonStyle | undefined;
  on_click: Array<IAction>;
  /**
   * Optional for non-SDUI logging or action.
   */
  logging_data: IElementLoggingData | undefined;
  /**
   * Used for accessibility purposes, describes what the button will do in the component.
   */
  content_description: string | undefined;
  text: string | undefined;
  icon: IFaireIcon | undefined;
  icon_and_text: IButtonElement.IFaireIconText | undefined;
}
